import {isRef} from "vue";

/**
 * Serializacja pod używania przez postMessage (które jest używane do komunikacji z service workerem) lub pod zapisywanie w local storage
 * Obiekty zawierające np. momenty, powinny zostać zserializowane przy użyciu tej funkcji przed wysłaniem wiadomości
 * @param element
 */
export function serialize(element: any) {
    return serializeValue(element);
}

/**
 * Serializuje pojedynczą wartość
 */
function serializeValue(value: any, key?: number | string , container?: object): string|object|null|boolean {
    if (isRef(value)) {
        value = value.value;
    }
    if(typeof value === 'undefined') {
        return 'undefined';
    } else if(value === null) {
        return null;
    } else if(typeof(value) === 'object' && value._isAMomentObject) {
        return 'moment:'+value.format('YYYY-MM-DD HH:mm:ss');
    } else if(typeof value === 'string') {
        return 'string:'+value;
    } else if(Array.isArray(value)) {
        return value.map((v,i,a) => serializeValue(v,i,a));
    } else if(typeof(value) === 'object') {
        const result:any = {};
        for(let k in value) {
            //@ts-ignore
            result[k] = serializeValue(value[k],k,value);
        }
        return result;
    }
    return value;
}

export function deserialize(element: any) {
    return deserializeValue(element);
}

/**
 * Deserializuje pojedynczą wartość
 * @param value
 * @param key
 * @param container
 */
function deserializeValue(value: any, key?: number | string , container?: object): any {
    if(typeof value === 'string') {
        if(value == 'undefined') {
            return undefined;
        }
        const valueType = value.substring(0, value.indexOf(':'));
        switch(valueType) {
            case 'moment':
                return self.moment(value.substring(valueType.length+1), 'YYYY-MM-DD HH:mm:ss');
            case 'string':
                return value.substring(valueType.length+1);
        }
    }
    if(!value) {
        return value;
    }
    if(Array.isArray(value)) {
        return value.map((v,i) => deserializeValue(v,i,value));
    } else if(typeof(value) === 'object') {
        let result = {};
        for(let k in value) {
            //@ts-ignore
            result[k] = deserializeValue(value[k],k,value);
        }
        return result;
    }
    return value;
}